/**
 * Use Case: Fetch Report Detail
 * Business logic for fetching paginated report detail data
 */

import type { ReportDetailData } from '../model/DashboardModel';
import type { IDashboardRepository } from '../repository/IDashboardRepository';
import { container, TYPES } from '../../di/DashboardModule';

export const FetchReportDetailUseCase = async (
  page: number = 1,
  pageSize: number = 10
): Promise<ReportDetailData> => {
  const repository = container.get<IDashboardRepository>(TYPES.IDashboardRepository);
  return repository.fetchReportDetail(page, pageSize);
};
